import styled from "styled-components";
import {fontFamilies} from "theme/tokens";

/** The row under the share link: "Show QR code" at its start, the Play control at its end (kitecorp/transferify-ui#3320). */
export const ActionsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 4px 12px;
	min-height: 30px;
	min-width: 0;
`;

/** The link under the QR in its dialog: one line, ending in an ellipsis like the link box's. */
export const QrDialogLink = styled.p`
	margin: 0;
	max-width: 100%;
	font: 600 13px/1.6 ${fontFamilies.sans};
	color: ${({theme}) => theme.tokens.ink2};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
